// Issues + Locations queries (PG server — reliability feature).
// Field sets mirror typeDefs/issue.ts. Subscriptions/mutations live alongside.

const ISSUE_FIELDS = /* GraphQL */ `
    id
    ownerId
    workspaceId
    source
    status
    title
    description
    images
    taskListUnitId
    locationId
    taskId
    taskReportId
    auditRunId
    sourceRef
    reportedBy
    overdueCount
    lastSignalAt
    resolutionType
    correctiveTaskId
    resolutionNote
    dismissComment
    resolvedBy
    resolvedAt
    archivedAt
    version
    createdAt
    updatedAt
    createdBy
    updatedBy
    deletedAt
`;

const LOCATION_FIELDS = /* GraphQL */ `
    id
    ownerId
    workspaceId
    name
    address
    archived
    mainTaskListUnitId
    version
    createdAt
    updatedAt
    createdBy
    updatedBy
    deletedAt
`;

export const ISSUE_FIELDS_GQL = ISSUE_FIELDS;
export const LOCATION_FIELDS_GQL = LOCATION_FIELDS;

export const listIssues = /* GraphQL */ `
  query listIssues($workspaceId: String!, $source: String, $status: String, $locationId: String, $taskListUnitId: String, $reportedBy: String, $limit: Int, $nextToken: String) {
    listIssues(workspaceId: $workspaceId, source: $source, status: $status, locationId: $locationId, taskListUnitId: $taskListUnitId, reportedBy: $reportedBy, limit: $limit, nextToken: $nextToken) {
      items { ${ISSUE_FIELDS} }
      nextToken
    }
  }
`;

export const getIssue = /* GraphQL */ `
  query getIssue($id: ID!) {
    getIssue(id: $id) { ${ISSUE_FIELDS} }
  }
`;

export const listLocations = /* GraphQL */ `
  query listLocations($workspaceId: String!, $includeArchived: Boolean, $limit: Int, $nextToken: String) {
    listLocations(workspaceId: $workspaceId, includeArchived: $includeArchived, limit: $limit, nextToken: $nextToken) {
      items { ${LOCATION_FIELDS} }
      nextToken
    }
  }
`;

export const getLocation = /* GraphQL */ `
  query getLocation($id: ID!) {
    getLocation(id: $id) { ${LOCATION_FIELDS} }
  }
`;
